import { prefixObjectValues } from "../../../utils"
import form from "./form"
import table from "./table"

const top = prefixObjectValues({
  openCreateModal: 'open-create-modal',
  selectActiveFilter: 'active-filter',
}, 'account-licenses-cds')

export default {
  form,
  table,
  ...top
}
